import { observable, configure, action } from 'mobx';
import util from 'preact-util';
import LocalModel from './localModel';

configure({ enforceActions: 'always' });

class CommissionStore extends LocalModel {
    constructor() {
        super('commissionUser', {
            namePlural: 'commissionUsers',
            namePluralReal: 'users',
            sort: 'id',
            limit: 50,
            api: {
                // We override saveField, so these are only here for completeness.
                search: { url: '/api/users/', params: {} },
                load: { url: '/api/users/', params: {} },
                save: { url: '/api/users/', params: {} },
            },
        });
    }

    // The object FormFieldsCompact binds to (holdingStore[objectName] with objectName='user').
    @observable user = {};

    @observable commissionUsers = [];

    // Set the user/member that the form should edit.
    @action
    setUser(user = {}) {
        this.updateKeyValue('user', { ...user });
    }

    // FormFieldsCompact calls updateField for local (memory) updates in some flows.
    updateField(id, key, value) {
        this.updateObjectKeyValue('user', key, value);
    }

    // FormFieldsCompact saves a single field by calling holdingStore.saveField(idAsInt, name, value).
    // We override it to hit the dedicated commission endpoint, sending only the changed field.
    saveField = async (id, key, value) => {
        // Optimistic local update so getValue() reflects the change immediately.
        this.updateObjectKeyValue('user', key, value);

        const response = await util.fetchApi('/api/users/commission', { method: 'PATCH' }, {
            id,
            [key]: value,
        });
        return response;
    }
}

const commissionStore = new CommissionStore();
export default commissionStore;
